import { setLocale } from 'yup';

import yupLocale from '@common/models/yup-locale';

export const configureYup = () => setLocale(yupLocale);
